import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTachometerAlt,
  faBriefcase,
  faUsers,
  faComments,
  faBars,
  faCog,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import { url } from "../../data/url";

function Navbar({ isOpen, toggleNavbar, setIsOpen }) {
  const navigate = useNavigate();
  const navbarRef = useRef(null);
  const hamburgerRef = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        isOpen &&
        navbarRef.current &&
        !navbarRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setIsOpen]);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  const handleSignOut = async () => {
    try {
      const res = await axios.post(`${url.path}/logout`, {}, { withCredentials: true });

      if(res.status === 200) {
        setDropdownOpen(false);
        navigate('/login');
      }
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <>
      <div className="navbar-toggle">
        <div className="ham-logo-container">
        <button ref={hamburgerRef} className="hamburger" onClick={toggleNavbar}>
          <FontAwesomeIcon icon={faBars} />
        </button>
        <div className="logo">
          <span className="logo-text">Amie</span>
        </div>
        </div>
        <div className="profile-icon">
          <button onClick={toggleDropdown}>
            <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%231d93ca'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z'/%3E%3C/svg%3E" alt="Profile" />
          </button>
          {dropdownOpen && (
            <div ref={dropdownRef} className="dropdown-menu">
              <Link to="profile-settings" onClick={() => setDropdownOpen(false)}>
                <FontAwesomeIcon icon={faCog} />
                <span>Profile Settings</span>
              </Link>
              <button onClick={handleSignOut}>
                <FontAwesomeIcon icon={faSignOutAlt} />
                <span>Sign Out</span>
              </button>
            </div>
          )}
        </div>
      </div>
      <nav ref={navbarRef} className={`navbar ${isOpen ? "open" : "closed"}`}>
        <ul className="nav-items">
          <Link to="post-job">
            <li className="nav-item">
              <FontAwesomeIcon icon={faPlus} className="icon" />
              <span>Post an Internship</span>
            </li>
          </Link>
          <Link to="dashboard">
            <li className="nav-item">
              <FontAwesomeIcon icon={faTachometerAlt} className="icon" />
              <span>Dashboard</span>
            </li>
          </Link>
          <Link to="internship">
            <li className="nav-item">
              <FontAwesomeIcon icon={faBriefcase} className="icon" />
              <span>Internships</span>
            </li>
          </Link>
          <Link to="candidates">
            <li className="nav-item">
              <FontAwesomeIcon icon={faUsers} className="icon" />
              <span>Candidates</span>
            </li>
          </Link>
          {/* <Link to="messages">
            <li className="nav-item">
              <FontAwesomeIcon icon={faComments} className="icon" />
              <span>Messages</span>
            </li>
          </Link> */}
        </ul>
      </nav>
    </>
  );
}

export default Navbar;